import '../styles/app.scss';

/** Autoload */
import './autoload/vanilla-jq';
import './autoload/_bootstrap';
import './autoload/_fonts';
import fetchInject from 'fetch-inject';
import formToObject from 'form_to_object';
import { debounce } from 'tiny-throttle';

/* Global vars */
window.debounce = debounce;
window.fetchInject = fetchInject;
window.formToObject = formToObject;

/** Util */
import './util/root';
import './util/app-height';
import './util/current-breakpoint';
import './util/splide-resize-height-of-slider';
import './util/body-top-padding';
import './util/scrollbar-width';

/** Global */
import './global/global';
import './global/header';
import './global/footer';

/**  Components */
import './components/splide-slider';
import './components/card';
import './components/dropdown';
import './components/checkbox-radio';
import './components/card-grid-filters';
import './components/cards-container';
import './components/url-updater';
import './components/filter-tags';
import './components/cta-cards';

/** Modules */
import './blocks/text-plus-media-slider';
import './blocks/tabbed-content';
import './blocks/team-grid';
import './blocks/card-grid-with-filters';
import './blocks/accordion';

/** Partials */
import './partials/filters-toggle';
